import { render, staticRenderFns } from "./IconEditPrimary.vue?vue&type=template&id=c16143c2&"
var script = {}
import style0 from "./IconEditPrimary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c16143c2')) {
      api.createRecord('c16143c2', component.options)
    } else {
      api.reload('c16143c2', component.options)
    }
    module.hot.accept("./IconEditPrimary.vue?vue&type=template&id=c16143c2&", function () {
      api.rerender('c16143c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconEditPrimary.vue"
export default component.exports